import * as Sentry from '@sentry/react';
import { onError } from '@apollo/client/link/error';

import { ResponseErrorCode } from './types';

export const sentryMiddleware = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, extensions }) => {
      const isInvalidSession =
        extensions?.code === ResponseErrorCode.ExpiredAccessToken ||
        extensions?.code === ResponseErrorCode.InvalidAccessToken;

      if (!isInvalidSession) {
        Sentry.captureMessage(message);
      }
    });
  }

  if (networkError) {
    Sentry.captureException(networkError);
  }
});
